import { useState } from "react";
import { Globe2 } from "lucide-react";
import { toast } from "sonner";
import { useAuth } from "@/context/AuthContext";
import { detectedTimezone } from "@/lib/api";
import { TimezoneSelect, saveTimezone } from "@/components/TimezonePrompt";

const pretty = (tz) => (tz || "").replace(/_/g, " ");

export function TimezoneRow({ reminders, onChanged }) {
  const { user, setUser } = useAuth();
  const home = user?.timezone || detectedTimezone();
  const [editing, setEditing] = useState(false);
  const [pick, setPick] = useState(home);
  const offZone = reminders.filter((r) => r.timezone && r.timezone !== home).length;

  const apply = async (tz) => {
    try {
      const r = await saveTimezone(tz, setUser);
      toast.success(`Time zone: ${pretty(tz)}${r.reminders_moved ? ` · ${r.reminders_moved} reminder${r.reminders_moved === 1 ? "" : "s"} updated` : ""}.`);
      setEditing(false);
      onChanged?.();
    } catch { toast.error("Couldn't save that time zone."); }
  };

  return (
    <div className="rounded-2xl border border-stone-200 bg-stone-50 p-3 text-sm" data-testid="timezone-row">
      <div className="flex flex-wrap items-center gap-2">
        <Globe2 className="w-4 h-4 text-amber-700" />
        <span className="text-stone-700">Your time zone: <strong data-testid="timezone-current">{pretty(home)}</strong>{home === detectedTimezone() && <span className="text-xs text-stone-500"> (matches this device)</span>}</span>
        <button type="button" onClick={() => setEditing((v) => !v)} data-testid="timezone-change" className="ml-auto text-xs font-semibold text-amber-800 hover:text-amber-900">{editing ? "Cancel" : "Change"}</button>
      </div>
      {editing && (
        <div className="flex gap-2 mt-2">
          <div className="flex-1"><TimezoneSelect value={pick} onChange={setPick} testid="timezone-select" /></div>
          <button type="button" onClick={() => apply(pick)} data-testid="timezone-save" className="amber-btn text-xs px-4">Save</button>
        </div>
      )}
      {offZone > 0 && (
        <button type="button" onClick={() => apply(home)} data-testid="timezone-apply-all" className="mt-2 text-xs font-semibold text-amber-900 underline underline-offset-2">
          {offZone} reminder{offZone === 1 ? " is" : "s are"} set in another zone — use my time zone for all reminders
        </button>
      )}
    </div>
  );
}
